import Api from '@/api/helpers';
import { useAppDispatch } from '@/hooks/customHooks';
import React, { useState, useEffect } from 'react';

const Heartbeat: React.FC = () => {
  const dispatch = useAppDispatch();

  const [displayText, setDisplayText] = useState('Loading...');

  const heartbeatCheck = async () => {
    const client = Api.getHeartbeatClient(dispatch);
    await client
      .heartbeat()
      .then((e) => {
        setDisplayText(e.replace('API', 'React app'));
      })
      .catch((e) => {
        setDisplayText('Bill Composer React app is NOT available');
        console.log(e);
      });
  };

  useEffect(() => {
    heartbeatCheck();
  }, []);

  return <div>{displayText}</div>;
};
export default Heartbeat;
